// extracted by css-extract-rspack-plugin
export default {"badgedButton":"badgedButton-wUcRCo","diffWrap":"diffWrap-FTHjFW","diffDot":"diffDot-TFND2K"};